import "./multipleChoose.scss";
import { useEffect, useState } from "react";
import { OptionModel } from "../../../models/questionModel";
import MultipleChooseOption from "../../../../../common/components/inputFields/multipleChooseOption/multipleChooseOption";

export default function MultipleChoose(props: {
  optionsData?: OptionModel[];
  onChange?: (e: OptionModel[]) => void;
}) {
  const [options, setOptions] = useState<OptionModel[]>(
    props.optionsData ?? []
  );

  useEffect(() => {
    props.onChange?.(options);
  }, [options]);

  return (
    <div className="multiple-choose">
      {options.map((e, i) => (
        <MultipleChooseOption
          key={i}
          initialValue={e}
          onChange={(e) => {
            let temp = [...options];
            temp[i] = e;
            setOptions(temp);
          }}
          onClickDelete={() => {
            let temp = [...options];
            temp = temp.filter((e2) => e2 != e);
            setOptions(temp);
          }}
          isFocused={options.length - 1 == i}
          maxWidth="300px"
        />
      ))}
      <MultipleChooseOption
        value=""
        isEditable={false}
        placeholder="Add option"
        onChange={(e) => {
          setOptions([...options, { ...e, score: 0 }]);
        }}
        maxWidth="300px"
      />
    </div>
  );
}
